export const RESET_STUDYSETS = 'reset_studysets';
export const ADD_STUDYSETS = 'add_studysets';
export const UPDATE_BUILDING_STUDYSET = 'update_building_studyset';
export const RESET_BUILDING_STUDYSET = 'reset_building_studyset';
export const ADD_STUDYSET = 'add_studyset';
export const SET_CURRENT_STUDYSET = 'set_current_studyset';
export const SET_CURRENT_STUDYSET_STUDENTS = 'set_current_studyset_students';
export const SET_CURRENT_STUDYSET_ALL_STUDENTS = 'set_current_studyset_all_students';
export const SET_LESSONS_TOTAL_TIME_PRACTICED = 'set_lessons_total_time_practiced';
export const SET_CATEGORIES = 'set_categories'
export const UPDATE_BUILDING_ASSIGNMENTS = 'update_building_assignments'
export const RESET_BUILDING_ASSIGNMENTS = 'reset_building_assignments'
export const SET_CREATED_ASSIGNMENTS='set_created_assignments'
export const SET_LESSONS_TIME_PRACTICED = 'set_lessons_time_practiced';
export const SET_STUDYSET_TIME_PRACTICED = 'set_studyset_time_practiced';
export const RESET_LESSONS_TIME_PRACTICED = 'reset_lessons_time_practiced';
export const RESET_STUDYSET_TIME_PRACTICED = 'reset_studyset_time_practiced';
export const SET_STUDY_SET_FILTERS = 'set_study_set_filters';
export const SET_STUDY_SET_IS_FILTER = 'set_study_set_is_filter';
